/**
 * Menús del shell, copiados de `src/php/framebody/menuR.php` (mapa-vistas §2.1). Cada ítem
 * declara el permiso de la API que lo habilita; la UI nunca decide con IDs de membresía.
 */
export interface ItemMenu {
  etiqueta: string;
  ruta: string;
  permiso?: string;
}

export interface Menu {
  etiqueta: string;
  ruta?: string;
  permiso?: string;
  items?: ItemMenu[];
}

export function menuPrincipal(anio: number): Menu[] {
  return [
    // Las clases en vivo con Zoom se retiraron (Fase 12); quedan las grabadas.
    { etiqueta: 'Clases grabadas', ruta: '/live/grabaciones', permiso: 'live.history.access' },
    {
      etiqueta: 'Curso',
      items: [
        { etiqueta: `ENARM ${anio}`, ruta: '/curso-enarm' },
        { etiqueta: 'Clases', ruta: '/curso-enarm/clases' },
        { etiqueta: 'Talleres', ruta: '/curso-enarm/talleres', permiso: 'workshop.access' },
        { etiqueta: 'Biblioteca', ruta: '/curso-enarm/biblioteca' },
        { etiqueta: 'Exámenes', ruta: '/curso-enarm/examenes-prime' },
        {
          etiqueta: 'Inglés Médico – KeyPoints',
          ruta: '/manuales/ingles-medico',
          permiso: 'manual.medical_english.access',
        },
        {
          etiqueta: 'Mnemotecnias – SmartWords',
          ruta: '/manuales/mnemotecnias',
          permiso: 'manual.mnemonics.access',
        },
        { etiqueta: 'Avances', ruta: '/curso-enarm/avances', permiso: 'progress.access' },
        { etiqueta: 'Temario', ruta: '/curso-enarm/temario', permiso: 'study_plan.access' },
      ],
    },
    { etiqueta: 'Simulador', ruta: '/simulador' },
    {
      etiqueta: 'Manuales',
      items: [
        {
          etiqueta: 'Algoritmos',
          ruta: '/manuales/algoritmos',
          permiso: 'manual.algorithms.access',
        },
        {
          etiqueta: 'Ultra Resúmenes',
          ruta: '/manuales/ultra-resumenes',
          permiso: 'manual.ultra_summaries.access',
        },
        {
          etiqueta: 'Clasificaciones y Tablas ENARM',
          ruta: '/manuales/clasificaciones-y-tablas',
          permiso: 'manual.tables.access',
        },
        {
          etiqueta: 'Resúmenes de Guías GPC',
          ruta: '/curso-enarm/biblioteca/resumenes-gpc',
          permiso: 'library.gpc_summaries.access',
        },
        {
          etiqueta: 'Manual ENARM Plus',
          ruta: '/manuales/enarm-plus',
          permiso: 'manual.enarm_plus.access',
        },
      ],
    },
    {
      etiqueta: 'Biblioteca',
      items: [
        {
          etiqueta: 'Presentaciones',
          ruta: '/curso-enarm/biblioteca/presentaciones',
          permiso: 'library.presentations.access',
        },
        {
          etiqueta: 'Guías GPC',
          ruta: '/curso-enarm/biblioteca/guias-gpc',
          permiso: 'class.gpc_guides.access',
        },
        {
          etiqueta: 'Flashcards',
          ruta: '/curso-enarm/biblioteca/flashcards',
          permiso: 'library.flashcards.access',
        },
        {
          etiqueta: 'Evaluadas en el ENARM',
          ruta: '/curso-enarm/biblioteca/flashcards-evaluadas',
          permiso: 'library.flashcards.access',
        },
        {
          etiqueta: 'Video tips',
          ruta: '/curso-enarm/biblioteca/video-tips',
          permiso: 'library.videos.access',
        },
      ],
    },
    {
      etiqueta: `Temario ${anio}`,
      items: [
        {
          etiqueta: 'Temario completo',
          ruta: '/curso-enarm/temario',
          permiso: 'study_plan.access',
        },
        {
          etiqueta: 'Organizar estudio',
          ruta: '/curso-enarm/temario/organizar',
          permiso: 'study_plan.configure',
        },
        { etiqueta: 'Puntajes ENARM', ruta: '/puntajes-enarm' },
        { etiqueta: 'Pediatría', ruta: '/curso-enarm/clases?especialidad=pediatria' },
        { etiqueta: 'Ginecología', ruta: '/curso-enarm/clases?especialidad=ginecologia' },
        { etiqueta: 'Medicina Interna', ruta: '/curso-enarm/clases?especialidad=medicina-interna' },
        { etiqueta: 'Cirugía', ruta: '/curso-enarm/clases?especialidad=cirugia' },
      ],
    },
  ];
}

export const menuUsuario: ItemMenu[] = [
  { etiqueta: 'Avances', ruta: '/avances', permiso: 'progress.access' },
  { etiqueta: 'Licencias', ruta: '/licencias' },
  { etiqueta: 'Cartas y Constancias', ruta: '/constancias' },
  { etiqueta: 'Tu opinión', ruta: '/opinion' },
  { etiqueta: 'Mi Cuenta', ruta: '/cuenta' },
];

/** Título visible de cada ruta en construcción (todas las del plan §13.4). */
export function tituloDeRuta(pathname: string): string {
  const todos = [
    ...menuPrincipal(0).flatMap((m) => m.items ?? [{ etiqueta: m.etiqueta, ruta: m.ruta ?? '' }]),
    ...menuUsuario,
  ];
  return (
    todos.find((i) => i.ruta.split('?')[0] === pathname)?.etiqueta.replace(/ 0$/, '') ??
    'Consalud ENARM'
  );
}
